import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { API, axios } from "@/api";
import { useAuth } from "@/contexts/AuthContext";

const UnifiedStatusContext = createContext({});

export const useUnifiedStatus = () => useContext(UnifiedStatusContext);

export function UnifiedStatusProvider({ children }) {
  const { user } = useAuth();
  const [statusMap, setStatusMap] = useState({});

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const res = await axios.get(`${API}/tracker/unified-status`);
      setStatusMap(res.data || {});
    } catch {
      // silently fail — badge just won't show
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const getStatus = useCallback(
    (businessId) => statusMap[businessId]?.status || null,
    [statusMap]
  );

  const getDetail = useCallback(
    (businessId) => statusMap[businessId] || null,
    [statusMap]
  );

  return (
    <UnifiedStatusContext.Provider value={{ statusMap, getStatus, getDetail, refresh }}>
      {children}
    </UnifiedStatusContext.Provider>
  );
}
